import * as React from "react";
import { TextField, Typography, Box } from "@mui/material";
import classes from "./DatePicker.module.css";

/**
 * Reusable DatePicker for override fields.
 *
 * Props:
 *  label       - string  : field label shown above the input
 *  value       - string  : ISO date string "YYYY-MM-DD" or "" for empty
 *  onChange    - fn(val) : called with "YYYY-MM-DD" string or null when cleared
 *  error       - bool    : highlights field in error state
 *  helperText  - string  : validation message shown below field
 *  disabled    - bool    : makes field read-only
 */
const DatePicker = ({
  label,
  value,
  onChange,
  error = false,
  helperText = "",
  disabled = false,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 200 }}>
      <Typography
        sx={{
          fontFamily: "Urbanist, Verdana, Arial, sans-serif",
          fontSize: "1rem",
          fontWeight: "bold",
          color: "#3F5765",
          letterSpacing: "0.05rem",
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <TextField
        type="date"
        size="medium"
        disabled={disabled}
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        error={error}
        helperText={helperText}
        //InputLabelProps={{ shrink: true }}
        inputProps={{
          className: classes.dateInput,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "&.Mui-error fieldset": {
              borderColor: "#d32f2f",
            },
          },
          "& .MuiFormHelperText-root": {
            fontFamily: "Urbanist, Verdana, Arial, sans-serif",
            fontSize: "1rem",
          },
        }}
      />
    </Box>
  );
};

export default DatePicker;
